import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Swiper, { Pagination } from 'swiper';

Swiper.use([Pagination]);
gsap.registerPlugin(ScrollTrigger);

const TABLET_BREAKPOINT = 425;

class TechnologyCard {
	constructor() {
		this.technologies = document.querySelector('.technologies');

		if (!this.technologies) return;

		this.swiper = Swiper;
		this.initSlider = false;
		this.mobile = window.matchMedia(`(max-width: ${TABLET_BREAKPOINT}px)`);
		this.desktop = window.matchMedia(`(min-width: ${TABLET_BREAKPOINT}px)`);

		this.containerOuter = document.querySelectorAll('.container-outer *');
		this.technologiesCards = this.technologies.querySelector(
			'.technologies__cards',
		);
		this.technologiesItems = this.technologies.querySelectorAll(
			'.technologies__item',
		);
		this.technologyCards =
			this.technologies.querySelectorAll('.technology-card');

		window.addEventListener('load', () => this.init());
		window.addEventListener('resize', () => this.init());
	}
	init() {
		if (this.mobile.matches) {
			this.mobileAnimation();
		} else if (this.desktop.matches) {
			this.desktopAnimation();
		}
	}
	desktopAnimation() {
		if (this.initSlider) {
			this.swiper.destroy();
			this.initSlider = false;
		}

		const debounce = (func, wait) => {
			let timeout;
			return (...args) => {
				clearTimeout(timeout);
				timeout = setTimeout(func, wait, ...args);
				this.containerOuter.forEach((elem) => elem.classList.add('resize'));
			};
		};

		window.addEventListener(
			'resize',
			debounce(() => {
				this.containerOuter.forEach((elem) => elem.classList.remove('resize'));
			}, 250),
		);

		this.technologiesCards.classList.remove('swiper-backface-hidden');
		this.technologyCards[0].classList.add('_active');

		this.technologiesItems.forEach((elem) => {
			elem.addEventListener('click', (e) => {
				const target = e.currentTarget;
				this.technologiesItems.forEach((elem) => {
					elem.classList.remove('_active');
				});
				target.classList.add('_active');

				const id = target.dataset.technologiesId;
				this.technologyCards.forEach((elem) => {
					elem.classList.remove('_active');
				});
				this.technologyCards[id].classList.add('_active');
			});
		});
	}
	mobileAnimation() {
		if (!this.initSlider) {
			this.initSlider = true;
			this.swiper = new Swiper('[data-technologies-swiper]', {
				slidesPerView: 1.047,
				spaceBetween: 8,
				pagination: {
					el: '[data-technologies-swiper] .swiper-pagination',
					clickable: true,
				},
				on: {
					init: () => {
						setTimeout(() => {
							this.technologyCards[0].classList.add('_active');
						}, 0);
					},
					slideChange: () => {
						const index = this.swiper.realIndex;
						this.technologyCards.forEach((elem, i) => {
							elem.classList.toggle('_active', i === index);
						});
					},
				},
			});
		}
	}
}

export default new TechnologyCard();
